import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconNoRelation({ onClick, className, color = '#000' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge(' w-6 h-6 cursor-pointer', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.63083 10.4707C3.42922 10.6721 3.26928 10.9112 3.16016 11.1745C3.05104 11.4377 2.99487 11.7199 2.99487 12.0049C2.99487 12.2899 3.05104 12.572 3.16016 12.8353C3.26928 13.0985 3.42922 13.3377 3.63083 13.5391L10.4606 20.3689C10.662 20.5705 10.9012 20.7305 11.1645 20.8396C11.4277 20.9487 11.7099 21.0049 11.9949 21.0049C12.2798 21.0049 12.562 20.9487 12.8253 20.8396C13.0885 20.7305 13.3277 20.5705 13.5291 20.3689L20.3589 13.5391C20.5605 13.3377 20.7205 13.0985 20.8296 12.8353C20.9387 12.572 20.9949 12.2899 20.9949 12.0049C20.9949 11.7199 20.9387 11.4377 20.8296 11.1745C20.7205 10.9112 20.5605 10.6721 20.3589 10.4707L13.5291 3.64084C13.3277 3.43923 13.0885 3.27929 12.8253 3.17017C12.562 3.06105 12.2798 3.00488 11.9949 3.00488C11.7099 3.00488 11.4277 3.06105 11.1645 3.17017C10.9012 3.27929 10.662 3.43923 10.4606 3.64084L3.63083 10.4707Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
